import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useEffect, useState} from "react";
import paymethods from '../../models/paymethods'
import helpers from "../../helpers/common";
import useRootHook from "../../hooks/useRoot";
import {Check, Add, FormatListBulleted, Delete} from '@mui/icons-material';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Link as RouterLink, useSearchParams} from "react-router-dom";
import {Tooltip, ToggleButton, ToggleButtonGroup} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import TableToolbar from '../layout/TableToolbar';

export default function PayMethodIndex(props) {
    const [searchParams, setSearchParams] = useSearchParams()

    const [payMethodData, setPayMethodData] = useState([])
    const [refreshId, setRefreshId] = useState(0)
    const {setShowLoader, notify, showConfirm} = useRootHook()
    
    const stateFilter = searchParams.get('state') || 'all'

    const handleEnabledFilterChange = (event, newValue) => {
        if (newValue === null) return
        const newParams = new URLSearchParams(searchParams)
        newParams.delete('enabled')
        newParams.delete('available')
        newParams.delete('blocked')
        newParams.set('state', newValue)

        if (newValue === 'all') {
            newParams.set('blocked', 'false')
        } else if (newValue === 'active') {
            newParams.set('blocked', 'false')
            newParams.set('enabled', 'true')
        } else if (newValue === 'inactive') {
            newParams.set('blocked', 'false')
            newParams.set('enabled', 'false')
        } else if (newValue === 'blocked') {
            newParams.set('blocked', 'true')
        }
        setSearchParams(newParams)
    }

    useEffect(() => {
        setShowLoader(true)
        const filters = searchParams ? Object.fromEntries(searchParams) : {}
        console.log('[PayMethodIndex] Loading with filters:', filters)
        paymethods.index(filters)
            .then((data) => {
                console.log('[PayMethodIndex] Received data:', data?.length || 0, 'items')
                data && setPayMethodData(data)
                setShowLoader(false)
            }).catch((err) => {
                console.error('[PayMethodIndex] Error:', err)
                setShowLoader(false)
            })
    }, [searchParams, refreshId])

    const handleRefresh = () => {
        setRefreshId((prevId) => {
            return prevId + 1
        });
        return true;
    }

    const handleDelete = async (method) => {
        const confirmed = await showConfirm('Are you sure you want to proceed?', 'Delete Payment Method');
        if (!confirmed) return
        setShowLoader(true)
        paymethods.delete(method.id)
            .then((result) => {
                result && handleRefresh() && notify('Method deleted')
                setShowLoader(false)
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Payment methods"
                breadcrumbs={[['Dashboard', '/'], ['Paymethods', '/paymethods']]}
                actions={
                    <>
                        <Button to="/paymethods/add" component={RouterLink} variant="contained" startIcon={<Add />}>
                            Add method
                        </Button>
                        <Button onClick={handleRefresh} variant="outlined">
                            Refresh
                        </Button>
                    </>
                }
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
                <TableToolbar 
                    title="Payment methods" 
                    actions={
                        <ToggleButtonGroup
                            value={stateFilter}
                            size="small"
                            exclusive
                            onChange={handleEnabledFilterChange}
                            aria-label="Status filter"
                        >
                            <ToggleButton value="all">ALL</ToggleButton>
                            <ToggleButton value="active">Active</ToggleButton>
                            <ToggleButton value="inactive">Inactive</ToggleButton>
                            <ToggleButton value="blocked">Blocked</ToggleButton>
                        </ToggleButtonGroup>
                    }
                />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>System</TableCell>
                            <TableCell>Stripe Tag</TableCell>
                            <TableCell>Enabled</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payMethodData.map((row) => (
                            <TableRow key={`pm-${row.id}`}>
                                <TableCell>
                                    <Link color="primary" to={`edit?id=${row.id}`} component={RouterLink}>
                                        {`${row.name}`}
                                    </Link>
                                </TableCell>
                                <TableCell>{row.paysystem.name}</TableCell>
                                <TableCell>{row.paysystem?.key === 'stripe' ? (row.stripe_tag || '') : ''}</TableCell>
                                <TableCell>{row.enabled ? <Check fontSize="small" /> : ''}</TableCell>
                                <TableCell>{helpers.getDate(row.created)}</TableCell>
                                <TableCell align="right">
                                    <Tooltip title="View transactions">
                                        <IconButton to={`/transactions?paymethod_id=${row.id}`} component={RouterLink}>
                                            <FormatListBulleted fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete paymethod">
                                        <IconButton onClick={() => handleDelete(row)}>
                                            <Delete fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </SectionCard>
        </Grid>
    </React.Fragment>
}

